import { render, staticRenderFns } from "./AppointmentEditor.vue?vue&type=template&id=a20e98b6&"
import script from "./AppointmentEditor.vue?vue&type=script&lang=js&"
export * from "./AppointmentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports